import React from "react";
import AvailableToggle from "./AvailableToggle";
import IsgstToggle from "./IsgstToggle";


export default function AddEditModal({
  mode = "add",
  initial = null,
  categories = [],
  kotList = [],
  onCancel = () => {},
  onSave = () => {},
}) {
  const [form, setForm] = React.useState(() => ({
    item_id: initial?.item_id ?? "",
    item_name: initial?.item_name ?? "",
    price: initial?.price ?? "",
    available: Boolean(initial?.available ?? true),
    category: initial?.category ?? "",
    is_gst: Boolean(initial?.is_gst ?? true),
    kot_ip: initial?.kot_ip ?? "",
    image_url: initial?.image_url ?? "",
  }));

  const [errors, setErrors] = React.useState({});

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const validate = () => {
    const e = {};
    if (!String(form.item_name).trim()) e.item_name = "Name is required";
    if (!String(form.category).trim()) e.category = "Category is required";
    if (mode === "edit") {
      const idn = Number(form.item_id);
      if (!Number.isFinite(idn)) e.item_id = "Item Id must be a number";
    }
    const pn = Number(form.price);
    if (!Number.isFinite(pn) || pn <= 0) e.price = "Price must be > 0";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const submit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    const payload = {
      item_name: String(form.item_name).trim(),
      price: Number(form.price),
      available: !!form.available,
      category: String(form.category).trim(),
      is_gst: !!form.is_gst,
      ...(form.kot_ip !== undefined ? { kot_ip: form.kot_ip } : {}),
      ...(form.image_url !== undefined ? { image_url: form.image_url } : {}),
    };
    if (mode === "edit") {
      payload.item_id = Number(form.item_id);
    }
    onSave(payload);
  };

  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal" role="dialog" aria-modal="true" onClick={(e)=>e.stopPropagation()}>
        <div className="modal-header">
          <h3>{mode === "add" ? "Add Item" : "Edit Item"}</h3>
        </div>

        <form onSubmit={submit} className="modal-body">
          <div className="form-row">
            <label>Item Id</label>
            <input
              type="number"
              value={form.item_id}
              onChange={(e) => set("item_id", e.target.value)}
            />
            {errors.item_id && <div className="err">{errors.item_id}</div>}
          </div>

          <div className="form-row">
            <label>Item Name</label>
            <input
              type="text"
              value={form.item_name}
              onChange={(e) => set("item_name", e.target.value)}
            />
            {errors.item_name && <div className="err">{errors.item_name}</div>}
          </div>

          <div className="form-row">
            <label>Price (₹)</label>
            <input
              type="number"
              value={form.price}
              onChange={(e) => set("price", e.target.value)}
            />
            {errors.price && <div className="err">{errors.price}</div>}
          </div>

          <div className="form-row">
            <label>Category</label>
            <input
              list="category-options"
              type="text"
              value={form.category}
              onChange={(e) => set("category", e.target.value)}
              placeholder="Select or type a category"
            />
            <datalist id="category-options">
              {categories.map((cat, index) => (
                <option key={index} value={cat} />
              ))}
            </datalist>
            {errors.category && <div className="err">{errors.category}</div>}
          </div>

          <div className="form-row">
            <label>Image Url</label>
            <input
              type="text"
              value={form.image_url}
              onChange={(e) => set("image_url", e.target.value)}
              placeholder="please add image url"
            />
          </div>

          <div className="form-row">
            <label>Kot</label>
            <select
              value={form.kot_ip}
              onChange={(e) => set("kot_ip", e.target.value)}
              className="kot-select"
            >
              <option value="">Select KOT</option>
              {kotList.map((kot, index) => {
                const value = typeof kot === 'string' ? kot : kot.kot_name;
                return (
                  <option key={index} value={value}>
                    {value}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="form-row">
            <label>Available</label>
            <AvailableToggle
              checked={!!form.available}
              onChange={(v) => set("available", v)}
            />
          </div>
          <div className="form-row">
            <label>Gst</label>
            <IsgstToggle
              checked={!!form.is_gst}
              onChange={(v) => set("is_gst", v)}
            />
          </div>

          <div className="modal-footer">
            <button type="button" className="modal-btn" onClick={onCancel}>Cancel</button>
            <button type="submit" className="modal-btn">
              {mode === "add" ? "Add" : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

